@if (episodeItem(); as episode) {
@if (showBadge()) {
<div class="badge-container">
    <badge [badge]="episode.badge" [variant]="BadgeVariant.Episode"
        [availabilityStartTime]="episode.availabilityStartTime"
        [availabilityEndTime]="episode.availabilityEndTime"
        [hasOutgoingEnabled]="hasOutgoingEnabled()"
        [hasUpcomingEnabled]="hasUpcomingEnabled()"
        [showAutomaticBadge]="showAutomaticBadge()"
        (availabilityStartPassed)="onAvailabilityStartPassed($event)"></badge>
</div>

}
<div (click)="play()" class="content-item inPlayer" [class.opened]="opened()" [class.active]="isPlaying()">
    <div class="media-wrapper" [transcodeImage]="episode.posterLandscape">
        @if(showPlayButton()){
        <rounded-icon-button class="media-play" [imgSrc]="skinning.getImage('icon_play')"></rounded-icon-button>
        }
        <div class="media-progress-bar">
            <div class="media-progress-fill" data-testid="player_series-episode-progress" [style.width.%]="bookmarkPercentage()"></div>
        </div>
    </div>
    <div class="content-info">
        <div class="media-header">
            <div class="media-title">{{episode.title}}</div>
        </div>

        <div class="info">
            @if (converter.formatAssetDurationToTime(episode); as durationLabel) {
            <div>
                <img class="me-2"
                    src="{{skinning.getImage('icon_duration')}}">{{durationLabel}}
            </div>
            }
            @if (episode.contentRating) {
            <div>
                <img class="me-2" src="{{skinning.getImage('icon_pg')}}">{{episode.contentRating}}
            </div>
            }
            @if (episode.productionYear) {
            <div>{{episode.productionYear}}</div>
            }
        </div>
    </div>
</div>
}
